module.exports = new __parcel__URL__("Archerskill_20.ec5a8aa4.png").toString();